import React from "react";
import type { FormData } from "../types";
import type { ColorSchemeOption } from "../SlideTemplates";

interface ColorSchemeSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
  colorSchemeOptions: ColorSchemeOption[];
}

const ColorSchemeSection: React.FC<ColorSchemeSectionProps> = ({
  formData,
  onFormChange,
  colorSchemeOptions,
}) => {
  return (
    <div className="md:col-span-2">
      <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
        Esquema de Cores *
      </label>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {colorSchemeOptions.map((scheme) => (
          <button
            key={scheme.value}
            type="button"
            onClick={() => onFormChange("colorScheme", scheme.value)}
            className={`p-4 rounded-xl border-2 transition flex flex-col items-center gap-2 ${
              formData.colorScheme === scheme.value
                ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20"
                : "border-(--border-color) hover:border-blue-500 bg-(--card-bg)"
            }`}
          >
            <div
              className="w-8 h-8 rounded-full mb-2"
              style={{ backgroundColor: scheme.color }}
            />
            <span
              className="text-sm font-medium"
              style={{
                color:
                  formData.colorScheme === scheme.value
                    ? "#1967d2"
                    : "var(--text-primary)",
              }}
            >
              {scheme.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ColorSchemeSection;
